import { textStyles, colors, loadingDark, loadingLight } from '../../shared/styles';

export const styles = {
  container: (isOnIrp) => ({
    marginBottom: (!isOnIrp) ? 35 : 0,
  }),
  title: {
    position: 'relative',
    minHeight: 12,
    marginBottom: 13,
    ...textStyles.sectionHead,
  },
  tempContainer: {
    position: 'relative',
    minHeight: 45,
  },
  temps: {
    display: 'inline-block',
    verticalAlign:'middle',
    marginRight: 20,
    fontSize: 40,
    lineHeight: '1em',
    color: colors.textColor
  },
  irpTemps: {
    display: 'inline-block',
    fontSize: 21,
  },
  pipe: {
    position: 'relative',
    top: '-2px',
    display: 'inline-block',
    height: '1em',
    width: 0,
    verticalAlign: 'middle',
    margin: '0 12px',
    borderRight: '1px solid '+ colors.greyLine,
  },
  tempUnit: (isOnIrp) => ({
    fontSize: (isOnIrp) ? 14 : 24,
    color: (isOnIrp) ? colors.grey : colors.textColor,
  }),
  iconContainer: (isOnIrp) => ({
    display: 'inline-block',
    verticalAlign:'top',
    textAlign: 'center',
    marginLeft: (isOnIrp) ? 15 : 0,
  }),
  icon: (isOnIrp) => ({
    display: 'inline-block',
    fontSize: (isOnIrp) ? 17 : 24,
    color: colors.textColor,
  }),
  summary: {
    textTransform: 'capitalize',
    fontSize:'10px',
  },

  loadingTitle: (show) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 2,
    width: '50%',
    height: 12,
    pointerEvents: 'none',
    ...loadingDark,
    opacity: (show) ? 1 : 0,
    transition: 'opacity 0.3s',
  }),
  loadingWeather: (show) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 2,
    width: '80%',
    height: 40,
    pointerEvents: 'none',
    ...loadingLight,
    opacity: (show) ? 1 : 0,
    transition: 'opacity 0.3s',
  }),
  noWeather: {
    fontSize: 14,
    color: colors.grey
  }
};
